import { Table } from "antd";
import { useEffect, useState } from "react";
import { AntdTable, ContainerDiv, TableContainer } from "./styles";

export default function IAPlanTable({
	data,
	columns,
	loading,
	containerMarginTop = null,
	containerBackground = null,
	background = null,
	rowBackground = null,
	showHeader = true,
}) {
	const [pagination, setPagination] = useState({
		current: 1,
	});

	const fetchData = async (params = {}) => {
		await fetch(params.pagination.current);

		setPagination({
			...params.pagination,
		});
	};

	useEffect(() => {
		if (!data) return;
		setPagination({
			...pagination,
			total: data.totalCount,
			pageSize: data.pageSize,
			current: data.pageNumber,
			showTotal: (total) => `Total ${total} items`,
		});
	}, [data]);

	const handleTableChange = (newPagination, filters, sorter) => {
		fetchData({
			sortField: sorter.field,
			sortOrder: sorter.order,
			pagination: newPagination,
			...filters,
		});
	};

	return (
		<TableContainer
			containerBackground={containerBackground}
			containerMarginTop={containerMarginTop}
		>
			<AntdTable
				columns={columns}
				dataSource={data}
				pagination={false}
				onChange={handleTableChange}
				rowKey={(record) => record.id}
				loading={loading}
				background={background}
				rowBackground={rowBackground}
				showHeader={showHeader}
			/>
		</TableContainer>
	);
}
